import { debounce } from 'cerebral/operators'

import focusField from '../actions/focusField'
import unFocusLastField from '../actions/unFocusLastField.js'

export default [
  debounce(50, [unFocusLastField, focusField], {
    immediate: true,
    throttle: true
  })
]



// WEBPACK FOOTER //
// ./src/modules/client/chains/focusField.js